import React, { useState } from "react";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import css from "./mobileFilterModal.module.css";
import { Button } from "../../../../../stories/Button/Button";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { DropDown } from "../../../../../stories/DropDown/DropDown";
import { Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import {
  CancelIconBlack,
  BookmarkIconBlack,
} from "../../../../../constant/imagePath";
import Colors from "../../../../../stories/assets/Colors";
import { ReactSVG } from "react-svg";
import ModalSkeletonCssClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";
import MonthSmallCalander from "../../../../../components/MonthSmallCalander";
import { MobileFilter } from "../../../../../stories/MobileFilter/MobileFilter";

const MobileFilterModal = ({
  show,
  setShow,
  location,
  setLocation,
  dates,
  setDates,
  lessonType,
  setLessonType,
}) => {
  const [tabState, setTabState] = useState("Day");
  return (
    <>
      <style>{`
      .${ModalSkeletonCssClasses.body} {
        padding: 0px;
      }
          .modal .modal-dialog {
            width: 100% !important;
            margin: 0px !important;
          }
          .modal .modal-dialog {
            max-width: 100% !important;
            height: 100%;
        }
        .modal-content{
            min-height:100%
        }
        .modal { 
            border-radius: 0px;
            background: white;
          }
    `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        borderRadius={"0px"}
        width={"100%"}
      >
        <Row className={`g-0 `}>
          <>
            <Col sm={12} md={12}>
              <div
                className={` ${[css.filterHeader].join(" ")}`}
                style={{
                  borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                }}
              >
                <ReactSVG
                  src={CancelIconBlack}
                  onClick={() => setShow(false)}
                />

                <h6
                  style={{
                    ...Fonts.b3,
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  Filters
                </h6>
                <ReactSVG
                  src={BookmarkIconBlack}
                // onClick={() => setIsSavedFilter(true)}
                />
              </div>
            </Col>
            <Col sm={12} md={12} className={css.contentContainer}>
              <div
                className={[css.pb24].join(" ")}
                style={{
                  borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                }}
              >
                <div className={[css.DropDownDiv].join(" ")}>
                  <DropDown
                    label={"Choose location"}
                    placeholder={"All"}
                    options={[
                      {
                        value: "All",
                        label: "All",
                      },
                      {
                        value: "Royal-Tennis-Court",
                        label: "Royal Tennis Court",
                      },
                      {
                        value: "Green-Tennis-Court",
                        label: "Green Tennis Court",
                      },
                    ]}
                    setter={setLocation}
                    state={location}
                  />
                </div>
                <div className={[css.DropDownDiv, css.mt32].join(" ")}>
                  <DropDown
                    label={"Lesson Type"}
                    placeholder={"All"}
                    options={[
                      {
                        value: "All",
                        label: "All",
                      },
                      {
                        value: "Evaluated",
                        label: "Evaluated",
                      },
                      {
                        value: "Not evaluated",
                        label: "Not evaluated",
                      },
                    ]}
                    setter={lessonType}
                    state={setLessonType}
                  />
                </div>
              </div>

              <div className={[css.calenderDiv].join(" ")}>
                {/* <p>Single Calender will be displayed here</p> */}
                <MonthSmallCalander value={dates} setValue={setDates} />
              </div>

            </Col>
          </>
        </Row>
        {/* Fixed Buttons */}
        <div
          style={{
            borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
          className={[css.footerBtnsDiv].join(" ")}
        >
          <LinkButtonWithIcon
            text={"Clear All"}
            textColor={Colors.neutralShadesOfNero}
            customStyle={{
              ...Fonts.b1Mobile,
            }}
          />

          <Button
            label={"Apply"}
            customStyle={{
              ...Fonts.b1Mobile,
              padding: "12px 32px",
              border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              width: "156px",
            }}
            primary={true}
            size="Large"
          />
        </div>


      </ModalSkeleton>
    </>
  );
};
export default MobileFilterModal;
